<template>
  <div class="sh-bread-item">
    <RouterLink v-if="to" :to="to"><slot /></RouterLink>
    <span v-else><slot /></span>
    <!--  通过render函数创建i标签 -->
    <!-- <el-icon ><ArrowRight /></el-icon> -->
    <el-icon><DArrowRight /></el-icon>
  </div>
</template>
<script>
export default {
  name: "ShBreadItem",
  props: {
    to: {
      type: [String, Object],
      default: "",
    },
  },
};
</script>
<style coped lang="less"></style>
